// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "RoutingMetadataContentDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { RoutingMetadataUsageGenShape } from "./routing-metadata-usage.gen";

export const RoutingMetadataContentDtoGenShape = z.strictObject({
  tenures: z.array(z.string()),
  crisisFlags: z.array(z.string()),
  expectationsNarrative: z.string(),
  routingSummary: z.string(),
  detailedSummary: z.string(),
  reviewDate: z.string().optional(),
  promptVersion: z.string(),
  taggingSkillVersionId: z.string(),
  schemaVersion: z.number(),
  taggedAt: z.string(),
  sourceLastEdited: z.string().optional(),
  usage: RoutingMetadataUsageGenShape.optional(),
});
